import React from "react";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

// Franja del cliente con SISVEN / sucursal y acceso a editar el cliente.
export default function ClienteEditarCard({
  clienteSeleccionado,
  direccionSeleccionada,
  sisvenPedido,
  onEditarCliente,
}) {
  return (
    <Grid item xs={12}>
      <Box
        sx={{
          backgroundColor: "primary.50",
          border: "1px solid",
          borderColor: "grey.700",
          borderRadius: 1,
          p: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "grey.500",
            }}
          />
          <Box>
            <Typography variant="subtitle2" fontWeight="600">
              {clienteSeleccionado.razon_social} - SISVEN:{" "}
              {direccionSeleccionada?.sisven_id || sisvenPedido} •
              {direccionSeleccionada?.nombre_sucursal || direccionSeleccionada?.sucursal}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 0.6 }}>
          <Tooltip title="Editar cliente" placement="top" arrow>
            <IconButton
              size="small"
              onClick={onEditarCliente}
              sx={{ backgroundColor: "white", "&:hover": { backgroundColor: "grey.50" } }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Grid>
  );
}
